// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imagem-colaborador-container {
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease; 
}

.imagem-colaborador-container:hover {
  transform: scale(1.2); 
}

.imagem-colaborador {
  width: 100%;
  height: 100%;
  object-fit: cover; 
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/colaboradores.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".imagem-colaborador-container {\n  width: 50px;\n  height: 50px;\n  overflow: hidden;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.3s ease; \n}\n\n.imagem-colaborador-container:hover {\n  transform: scale(1.2); \n}\n\n.imagem-colaborador {\n  width: 100%;\n  height: 100%;\n  object-fit: cover; \n  border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
